import { takeLatest, put, call } from "redux-saga/effects";
import request from "../../../components/Utils/httpHelper";
import { CORE_API } from "../../../config";
import { HTTP_HEADERS } from "../../../constants";
import { Preloading } from "../../../components/UI/Preloader/action";
import { TASK_CONFIG } from "../constants";
import { DELETE_FINANCIAL_FORM_DATA } from "../actionTypes";
import { extractApiErrorMessage } from "../helper";
import {
  deleteFinancialFormDataSuccess,
  deleteFinancialFormDataFailure,
} from "../action";

export function* deleteFinancialFormDataSaga(action) {
  const { caseId } = action.payload || {};
  const requestURL = `${CORE_API}${TASK_CONFIG.DELETE_FINANCIAL_FORM_DATA.deleteEndpoint}`;

  try {
    const response = yield call(request, requestURL, {
      method: "DELETE",
      headers: HTTP_HEADERS,
      data: { caseId },
    });
    yield put(
      deleteFinancialFormDataSuccess({
        response: response.data,
      })
    );
  } catch (err) {
    yield put(
      deleteFinancialFormDataFailure({
        message: extractApiErrorMessage(
          err,
          "Failed to delete financial form data"
        ),
        status: "FAILURE",
      })
    );
  } finally {
    yield put(Preloading(false));
  }
}

export function* watchDeleteFinancialFormData() {
  yield takeLatest(DELETE_FINANCIAL_FORM_DATA, deleteFinancialFormDataSaga);
}
